<!--第三方登录路由-->
<template>
<div>
    <el-input v-model="url" placeholder="请输入URL"/>
    <el-input v-model="postStr" placeholder="请输入" :autosize="{ minRows: 2, maxRows: 4}"/>
    <el-button @click="sendTest">GO</el-button>

</div>
</template>

<script>

    import loginApi from '@/api/login'

    export default {
        name: 'Test',
        data(){
            return{
                url:"",
                postStr:"",
                postJson:{}
            }
        },
        methods:{
            sendTest: function() {
                let that = this
                let post = {}
                post.url = that.url
                post.data = JSON.parse(that.postStr);
                loginApi.post(post).then(res => {
                   
                });
            },
        }
    }

</script>

<style scoped>

</style>
